export default [
  'BOTOneColumnLoginPage'
]

/*
Appears on:
/login
*/
